import { motion } from "framer-motion";
import { Maximize2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

const WORKS = [
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/36ff1c127fbbfcc6_dji_mimo_20260923_135432_20260923135428_1790167092606_photo.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/1efa83bcbe1122f2_dji_mimo_20260923_135514_20260923135510_1790167091368_photo.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/527ce7bc7121b4fb_dji_mimo_20260923_135516_20260923135513_1790167093861_photo.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/519e22e270faec8f_dji_mimo_20260923_140244_20260923140242_1790167088479_photo.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/6b9dbddbe56f1b6c_dji_mimo_20260923_141842_20260923141839_1790167073272_photo.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/35b104f163f14c2d_dji_mimo_20260923_141930_20260923141928_1790167073580_photo.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/e5c16070f5f8393a_dji_mimo_20260923_142044_20260923142042_1790167072411_photo.webp",
];

export default function WorkGallery() {
    const { t } = useLanguage();
    const [lightbox, setLightbox] = useState(null);
    return (
        <section id="in-laboratorio" className="py-24 md:py-32 px-5 md:px-10 border-t border-zinc-200" data-testid="lab-gallery">
            <motion.h2
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
                className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight"
            >
                {t("lab.title")}
            </motion.h2>

            <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:balance]">
                {WORKS.map((src, i) => (
                    <motion.button
                        key={i}
                        type="button"
                        onClick={() => setLightbox(src)}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: (i % 3) * 0.12, duration: 0.6 }}
                        className="group relative block w-full mb-4 break-inside-avoid overflow-hidden bg-zinc-100 cursor-zoom-in"
                        data-testid={`lab-photo-${i}`}
                    >
                        <img
                            src={src}
                            alt={`${t("lab.title")} ${i + 1}`}
                            loading="lazy"
                            className="w-full h-auto block transition-transform duration-700 group-hover:scale-105"
                        />
                        <span className="absolute bottom-3 right-3 bg-white/90 backdrop-blur p-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                            <Maximize2 size={16} />
                        </span>
                    </motion.button>
                ))}
            </div>

            <Dialog open={!!lightbox} onOpenChange={() => setLightbox(null)}>
                <DialogContent
                    className="max-w-6xl p-0 bg-black/95 border-none"
                    data-testid="lab-lightbox"
                >
                    {lightbox && (
                        <img
                            src={lightbox}
                            alt={t("lab.title")}
                            className="w-full max-h-[85vh] object-contain"
                        />
                    )}
                </DialogContent>
            </Dialog>
        </section>
    );
}
